$(".header__icon--menu").click(function () {
  $(".bestsellet-mainnav").slick("refresh");
});

$(".head").click(function () {
  $(this).toggleClass("active");
  $(this).parent().find(".arrow").toggleClass("arrow-animate");
  $(this).parent().find(".content").slideToggle(280);
});

$(".clickmenu_mobilefirst a").click(function () {
  //alert('hello');
  //$('.Inermenu_section').slideToggle();
  $(this)
    .parent(".clickmenu_mobilefirst")
    .find(".Inermenu_section")
    .slideToggle();
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
  } else {
    $(this).addClass("active");
  }
});
  


$(".headingcontent").click(function () {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
  } else {
    $(this).addClass("active");
  }
});

$(".tabingsection button").click(function () {
  $(".tabingsection button").removeClass("active");
  $(this).addClass("active");
}); 

$(".tabingsection button").click(function () {
  var btnText = $(this).data("text");
  console.log(btnText);

  $(".tabingContent-sec").hide();
  $(`.${btnText}`).show();
});  
var __slidecartRefreshTimer = null;
function scheduleSlidecartRefresh() {
  if (__slidecartRefreshTimer) clearTimeout(__slidecartRefreshTimer);
  __slidecartRefreshTimer = setTimeout(function () {
    if (typeof window.SLIDECART_OPEN === "function") window.SLIDECART_OPEN();
    if (typeof window.SLIDECART_UPDATE === "function") window.SLIDECART_UPDATE();
  }, 120);
}

$('body').on('click', '.addtocart_button',function(e){ 
  //alert('hello');
  var id = $(this).data('id');
  var quantity = 1;
  var id = $(this).data('id'); 
  var dataTitle = $(this).data("title"); 
  var dataPrice = $(this).data("price");

  console.log("id", id);
  console.log("dataTitle", dataTitle);
  console.log("dataPrice", dataPrice);
   fbq('track', 'AddToCart', {
        content_name: dataTitle,  
        content_ids: [`'${id}'`],
        content_type: 'product',
        value: dataPrice,
        currency: 'INR' 
      }); 
  $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        items: [{id: id}],
      },
      success: (data) => {
        console.log('open')
        scheduleSlidecartRefresh();
      },
      error: (err) => {
        console.error("err", err);
      },
    }); 

  window.SLIDECART_UPDATED = function(cart) {
  //console.log("cart update", cart.item_count);
    $(".bubble_count").text(cart.item_count);
}
  
})

$("body").on("click", ".variants-imgsecinner img", function (e) {
  //alert('hello');
  e.preventDefault();
  $(this)
    .parents(".card__information")
    .find(".variants-imgsecinner img")
    .removeClass("activeimg");
  $(this).addClass("activeimg");
  var id = $(this).data("id");
  // premium pass: scope to THIS card (was global - selecting a shade on one
  // card used to change the variant added by EVERY card's button)
  $(this).parents(".card__information").find(".addtocart_button").attr("data-id", id);

  var dataTitle = $(this).data("title");
  $(this)
    .parents(".card__information")
    .find(".variantshade-text span")
    .text(dataTitle);
});

$(".hamburger-img").click(function () {
  $(".headerdrawer-sectionmain").addClass("active");
  $("body").addClass("hiddenOverflow");
});

$(".closebtn-section img").click(function () {
  $(".headerdrawer-sectionmain").removeClass("active");
  $("body").removeClass("hiddenOverflow");
});

$(".dropdown-menusec a").click(function () {
  $(this).toggleClass("active");
});

$("#dropdown-product").click(function () {
  $(this).toggleClass("active");
});

$(document).ready(function () {
  $("#myInput").on("keyup", function () {
    var value = $(this).val().toLowerCase();
    $("li.multicolumn-list__item.grid__item").filter(function () {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    });
  });
});

$("#closebtn_marquee").click(function () {
  $(".animationmarquee-sectionimage").remove();
});

/* premium pass: the +N pill now opens the quick-view popup
   (snippets/custom-quick-view-popup.liquid); old inline swap handlers removed */


document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".product-form__submit");
  if (button) {
    button.addEventListener("click", function () { 
      var title = $(this).data("title");
      var price = $('span.price-item.price-item--regular').text();  
      var variantId = $("variant-selects input:checked + label").data("varinatid");
    console.log("variantId", variantId);
      
      fbq('track', 'AddToCart', {
        content_name: title,  
        content_ids: [`'${variantId}'`],
        content_type: 'product',
        value: price,
        currency: 'INR' 
      }); 
    });
  }
});


$('.variants-imgsecinner span').on('click', function(){
  var this_text = $(this);
  
  setTimeout(function(){
  if(this_text.hasClass('main_var_sold_out')){
    this_text.parents('.card__content').find('.addtocart_button').text('Sold Out');
    this_text.parents('.card__content').find('.addtocart_button').addClass('add-no-sold-out');
  }else{
    this_text.parents('.card__content').find('.addtocart_button').text('Add To Cart');
    this_text.parents('.card__content').find('.addtocart_button').removeClass('add-no-sold-out');
  }
  }, 200);
})

$('.product-form__input label').on('click', function(){
  if($(this).hasClass('main_var_sold_out')){
    $('.shopify-payment-button').hide();
    $('.product-form__buttons button.product-form__submit').css({"width":"100%"})
  }else{
    $('.shopify-payment-button').show();
    $('.product-form__buttons button.product-form__submit').css({"width":"50%"})
  }
})

 if($('.product-form__input--pill input[type=radio]:checked+label').hasClass('main_var_sold_out')){
    $('.shopify-payment-button').hide();
   $('.product-form__buttons button.product-form__submit').css({"width":"100%"})
  }else{
    $('.shopify-payment-button').show();
   $('.product-form__buttons button.product-form__submit').css({"width":"50%"})
  }



$(window).on('load', function() {
    setTimeout(function() {
      $('#react-chatbot-container').css('display', 'block');
    }, 10000);
  });

document.querySelectorAll('.product-title-heading').forEach(function(el) {
    el.innerHTML = el.innerHTML.toLowerCase();
});

(function($) {
    $(window).on('load', function() {
        setOpacity();
        var attempts = 0;
        var interval = setInterval(function() {
            if (setOpacity() || attempts >= 25) clearInterval(interval);
            attempts++;
        }, 200);
    });

    function setOpacity() {
        var $badge = $('.bbbbb .jdgm-widget.jdgm-preview-badge');
        if ($badge.length) {
            $badge.css('opacity', '1');
            return true;
        }
        return false; 
    }
})(jQuery);
 
 
  document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname === "/products/free-lip-oil-cover") {
      window.location.href = "/";
    }
  }); 


  

/* premium pass: fill the card rating rows (.pp-rate) from the Judge.me badge
   data each card already carries; rows stay hidden until filled (CSS .pp-on).
   Anchored on .card-wrapper (not the li class) so it also works on search
   results, whose <li> lacks the reviewgrid-sec class. */
function ppFillRatings() {
  $('.pp-rate').not('.pp-on').each(function () {
    var $rate = $(this);
    var $badge = $rate.closest('.card-wrapper').find('.jdgm-prev-badge');
    if (!$badge.length) return;
    var avg = parseFloat($badge.data('average-rating'));
    var n = parseInt($badge.data('number-of-reviews'), 10);
    if (isNaN(avg) || avg <= 0 || isNaN(n) || n <= 0) { $rate.remove(); return; }
    var star = $rate.find('.pp-stars')[0];
    if (star) star.style.setProperty('--p', Math.min(100, Math.round(avg * 20)) + '%');
    $rate.find('.pp-rc').text('(' + n + ')');
    $rate.addClass('pp-on');
  });
}
$(document).ready(ppFillRatings);
setTimeout(ppFillRatings, 1500);
setTimeout(ppFillRatings, 5000);

setTimeout(function(){

$('.reviewgrid-sec').each(function () {

    var $item = $(this);
    var $badge = $item.find('.jdgm-prev-badge');

    var avgRating = parseFloat($badge.data('average-rating')); 
    var totalReviews = $badge.data('number-of-reviews');

    // If rating is missing, convert to 0
    if (isNaN(avgRating)) avgRating = 0;

    // ROUND rating to 1 decimal (4.5)
    var roundedRating = avgRating.toFixed(1);

    // Hide review section if rating is 0
    if (roundedRating == "0.0" || roundedRating == "0") {
        $item.find('.review-section').hide();
        return;
    }

    // Otherwise show values
    $item.find('.review-section').show();
    $item.find('.rating_point').text(roundedRating);
    $item.find('.rating_number').text(totalReviews);
});

},10000)
